import { useState } from "react";

const useModal = () => {
  const [isVisible, setIsVisible] = useState(false);

  const open = () => {
    setIsVisible(true);
  };

  const close = () => {
    setIsVisible(false);
  };

  return {
    isVisible,
    open,
    close,
  };
};

export default useModal;
